import React from 'react';
import { useNavigate } from 'react-router-dom';
// Nota: Importamos iconos dummy para mantener la estructura visual.
// Asumo que estos están disponibles en el path '../../assets/icons/...'
// Si no los tienes, puedes usar iconos de la biblioteca que uses (p. ej., react-icons)
// o crear componentes SVG placeholder.
// Usaré los iconos de tu ejemplo como placeholder.
import { ReactComponent as EventoIcon } from '../../assets/icons/EventosIcon.svg'; 
import { ReactComponent as DegustacionIcon } from '../../assets/icons/MiembrosIcon.svg';
import { ReactComponent as CataIcon } from '../../assets/icons/MenuIcon.svg';


function NuevoEvento() {
    const navigate = useNavigate();

    const handleFormSelection = (path) => {
        navigate(path);
    };

    // La función renderForm() ya no es necesaria, 
    // pero mantenemos la estructura visual en el return principal.

    return (
        <div className="Trazabilidad"> {/* Reutilizando el className principal */}
            <header className="trazabilidad-header">
                <div className="header-content">
                    <h1>Eventos</h1>
                </div>
            </header>
            
            <main className="trazabilidad-main-content">
                <div className="selection-container" >
                    <p>¿Qué tipo de evento querés generar?</p>
                    <div className="button-group" style={{ display: 'flex', gap: '20px' }}>
                        
                        {/* BOTÓN: EVENTO */}
                        <div
                            className="button-item"
                            onClick={() => handleFormSelection('/nuevo-evento')}
                            style={{ cursor: 'pointer', textAlign: 'center' }}
                        >
                            <EventoIcon className="trazabilidad-icon" />
                            <p>Evento</p>
                        </div>

                        {/* BOTÓN: DEGUSTACIÓN */}
                        <div
                            className="button-item"
                            onClick={() => handleFormSelection('/nueva-degustacion')}
                            style={{ cursor: 'pointer', textAlign: 'center' }}
                        >
                            <DegustacionIcon className="trazabilidad-icon" />
                            <p>Degustación</p>
                        </div>

                        {/* BOTÓN: CATA */}
                        <div
                            className="button-item"
                            onClick={() => handleFormSelection('/nueva-cata')}
                            style={{ cursor: 'pointer', textAlign: 'center' }}
                        >
                            <CataIcon className="trazabilidad-icon"  style={{width:'15vw'}}/>
                            <p>Demostración</p>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}

export default NuevoEvento;